import { css as d } from "styled-components";
const t = {
  xs: 320,
  sm: 360,
  md: 768,
  lg: 1024,
  xl: 1440
};
Object.values(t);
const x = t.xl, e = (s) => `${s}px`, m = (s) => (a) => d(["@media only screen and (", "){", ";}"], s, a), i = Object.keys(t).reduce((s, a) => (s[a] = m(`min-width: ${e(t[a])}`), s), {}), r = Object.keys(t).reduce((s, a) => {
  const c = {
    xs: t.sm,
    sm: t.md,
    md: t.lg,
    lg: t.xl
  };
  return s[a] = m(`max-width: ${e(c[a] - 1)}`), s;
}, {}), l = Object.keys(t).reduce((s, a) => {
  switch (t[a]) {
    case t.xs:
      s[a] = m(`max-width: ${e(t.sm - 1)}`);
      break;
    case t.sm:
      s[a] = m(`max-width: ${e(t.sm)}) and (max-width: ${e(t.md - 1)}`);
      break;
    case t.md:
      s[a] = m(`min-width: ${e(t.md)}) and (max-width: ${e(t.lg - 1)}`);
      break;
    case t.lg:
      s[a] = m(`min-width: ${e(t.lg)}) and (max-width: ${e(t.xl - 1)}`);
      break;
    case t.xl:
      s[a] = m(`min-width: ${e(t.xl)}`);
      break;
  }
  return s;
}, {});
export {
  t as S,
  i as a,
  l as b,
  x as c,
  r as m
};
